module.exports = __webpack_public_path__ + "8f92104d89a52144f27c9e55ab411604.MP3";